import React from "react";
import "./Features.css";

export const Features = (props) => {
  return (
    <div id="features">
      <div className="container">
        {/* Section Title */}
        <div className="row">
          <div className="col-xs-12">
            <div className="section-title text-center">
              <h2>私たちの強み</h2>
              <p>ReCoPilotが選ばれる4つの理由</p>
            </div>
          </div>
        </div>

        {/* Features Grid */}
        <div className="row features-grid">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.title}-${i}`} className="col-xs-12 col-sm-6 col-lg-3">
                  <div className="feature-card">
                    <div className="feature-icon-wrapper">
                      <i className={d.icon}></i>
                    </div>
                    <div className="feature-content">
                      <h3 className="feature-title">{d.title}</h3>
                      <p className="feature-description">{d.text}</p>
                    </div>
                  </div>
                </div>
              ))
            : "Loading..."}
        </div>
      </div>
    </div>
  );
};

